import { PARTNER_INTEGRATION_EVENT_PREFIX, trackMixpanelEvent } from '../utils/general';
import { ATTRIBUTION_TAB_IDS, REQUEST_TYPES } from './consts';
import { getFormTypeRules } from './formTypeRules';

// Per-request-type whitelist of toggle/dropdown answer fields included in submit/update
// payloads. To track a new toggle/dropdown question, add its form-data key here.
// Macro tables and free-text fields are intentionally not listed.
const INCLUDED_FIELDS = {
    [REQUEST_TYPES.ATTRIBUTION]: {
        [ATTRIBUTION_TAB_IDS.GENERAL]: [
            'platform_template',
            'platforms',
            'platforms_other',
            'campaign_objectives',
            'receive_postbacks',
            'installs_data_scope',
            'events_data_scope',
        ],
        [ATTRIBUTION_TAB_IDS.TRACKING_LINK_OPTIONS]: ['view_through_campaigns', 'click_impression_reporting_method'],
        [ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP]: [
            'postback_method',
            'different_domains_per_postback',
            'needs_app_level_macro',
            'enable_event_mapping',
            'postback_events_and_platforms',
        ],
    },
};

const extractToggleAnswers = (formData, requestType) => {
    const tabFields = INCLUDED_FIELDS[requestType];
    if (!tabFields || !formData) return {};
    const rules = getFormTypeRules(requestType);
    const answers = {};
    Object.entries(tabFields).forEach(([tabId, fields]) => {
        if (!rules.isTabVisible(formData, { id: tabId })) return;
        const tabData = formData[tabId] || {};
        fields.forEach(field => {
            if (tabData[field] !== undefined) {
                answers[field] = tabData[field];
            }
        });
    });
    return answers;
};

export const trackRequestSubmitted = ({ requestType, formData }) => {
    trackMixpanelEvent(PARTNER_INTEGRATION_EVENT_PREFIX, 'Request Submitted', {
        request_type: requestType,
        ...extractToggleAnswers(formData, requestType),
    });
};

export const trackRequestUpdated = ({ requestType, formData, status, isAdmin }) => {
    trackMixpanelEvent(PARTNER_INTEGRATION_EVENT_PREFIX, 'Request Updated', {
        request_type: requestType,
        status,
        is_admin: !!isAdmin,
        ...extractToggleAnswers(formData, requestType),
    });
};

export const trackRequestDeleted = ({ requestType, status }) => {
    trackMixpanelEvent(PARTNER_INTEGRATION_EVENT_PREFIX, 'Request Deleted', {
        request_type: requestType,
        status,
    });
};
